"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayMonitoringBluetoothDeviceDto = void 0;
class DisplayMonitoringBluetoothDeviceDto {
    displayId;
    localName;
    macAddress;
    rssi;
    timestamp;
}
exports.DisplayMonitoringBluetoothDeviceDto = DisplayMonitoringBluetoothDeviceDto;
